let appConfig = {
  REACT_APP_TENANT_ID: '',
  REACT_APP_NON_FED_DOMAIN_HINT: '',
  REACT_APP_TERMS_URL: '',
  REACT_APP_PRIVACY_URL: '',
  REACT_APP_COOKIE_URL: '',
};

export const setAppConfig = (config) => {
  appConfig = { ...config };
};

export const getAppConfig = () => appConfig;
